import api from "@/api/axios.js";

export async function listPromos(params = {}) {
	const { data } = await api.get("/api/promos", { params });
	return data?.items || [];
}

export async function getPromo(id) {
	const { data } = await api.get(`/api/promos/${id}`);
	return data?.promo || null;
}

export async function createPromo(payload) {
	const { data } = await api.post("/api/promos", payload);
	return data;
}

export async function updatePromo(id, payload) {
	const { data } = await api.patch(`/api/promos/${id}`, payload);
	return data;
}

export async function deletePromo(id) {
	const { data } = await api.patch(`/api/promos/${id}/delete`);
	return data;
}

export async function getPromoNextSerial(promoId, excludeFlyerId) {
	const params = excludeFlyerId ? { excludeFlyerId } : {};
	const { data } = await api.get(`/api/promos/${promoId}/next-serial`, { params });
	return data;
}

/**
 * Prenota atomicamente un blocco di `count` seriali promo-unici.
 * Fonte di verità lato server: il client non deve mai stimare i seriali.
 * Ritorna { ok, from, to, serials: number[] }.
 */
export async function reservePromoSerials(promoId, count = 1) {
	const { data } = await api.post(`/api/promos/${promoId}/reserve-serials`, { count });
	return data;
}

export async function getPromoSerials(promoId) {
	const { data } = await api.get(`/api/promos/${promoId}/serials`);
	return data;
}

export async function createFlyerInPromo(promoId, payload) {
	const { data } = await api.post(`/api/promos/${promoId}/flyers`, payload);
	return data;
}

export async function listPromoFlyers(promoId) {
	const { data } = await api.get("/api/flyers", { params: { promoId, limit: 500 } });
	return data?.items || [];
}
